import { CommonData } from "../../datastructures/gamestate/gameData";
import { StyleOfText } from "../../textStyle";

// Animated Number for jackpot

export class JackpotCounters {
  private parentContainer: PIXI.Container; //rootparent
  private textParent: PIXI.Container; //textOnlyParent used to get width of total text;
  private currentValue: number;
  private targetValue: number;
  private nextValue: number;
  private animationTimeToTarget: number;
  private maxLength: number;
  private textStyle: PIXI.TextStyle;
  private topText: Array<PIXI.Text>;
  private botText: Array<PIXI.Text>;
  private commaText: PIXI.Text;
  private textDefaultSpacing: number;
  private commaSpacing: number;
  private topTween: Array<PIXI.tween.Tween>;
  private speed: number;
  private step: number;
  // private skipAnimation: boolean;
  private deltaValue: number;
  private startTime: number;
  private reset: boolean;
  private lowerpartMask: PIXI.Graphics;
  private gameTextStyle: StyleOfText;
  private emptyText: PIXI.Text;
  private unavailableText: PIXI.Text;
  private activeGameData: CommonData;
  constructor(current: number, maxLength: number, activeGameData: CommonData) {
    this.activeGameData = activeGameData;
    this.currentValue = current; //x100 for display without commas
    this.targetValue = current;
    this.nextValue = this.currentValue + 1;
    this.animationTimeToTarget = 10000; //duration of animation
    this.parentContainer = new PIXI.Container();
    this.textParent = new PIXI.Container();
    this.maxLength = maxLength;
    this.gameTextStyle = new StyleOfText();
    this.textStyle = new PIXI.TextStyle({
      fontFamily: this.gameTextStyle.gameFont,
      fontSize: 35,
      fontWeight: "bold",
      fill: ["#ffffff"], // gradient
    });

    this.topText = [];
    this.botText = [];
    this.commaText;
    this.textDefaultSpacing = 25;
    this.commaSpacing = 10;
    this.topTween = [];
    this.speed;
    this.step = 1; //default animation steps speed
    // this.skipAnimation = false;
    this.deltaValue;
    this.startTime;
    this.reset = true;

    this.lowerpartMask = new PIXI.Graphics();

    this.create();
  }

  private create = (): void => {
    this.lowerpartMask.beginFill(0xff0000);
    this.lowerpartMask.drawRect(0, 0, 45 * this.maxLength + 45, 33);
    this.lowerpartMask.endFill();
    this.lowerpartMask.y = 3 + 3;
    this.lowerpartMask.x = -30;
    this.lowerpartMask.alpha = 0.75;
    this.parentContainer.addChild(this.lowerpartMask);

    this.parentContainer.addChild(this.textParent);
    for (var i = 0; i < this.maxLength; i++) {
      this.topText[i] = new PIXI.Text("0", this.textStyle);
      this.botText[i] = new PIXI.Text("0", this.textStyle);

      this.topText[i].x = i * this.textDefaultSpacing; //Default Spacing between Numbers
      if (i >= this.maxLength - 2) {
        this.topText[i].x += this.commaSpacing;
      }
      if (i === this.maxLength - 2) {
        this.commaText = new PIXI.Text(".", this.textStyle);
        this.commaText.x = i * this.textDefaultSpacing - 3; //Correcting offset
        this.textParent.addChild(this.commaText);
      }
      this.topText[i].addChild(this.botText[i]);
      this.botText[i].y = 45;
      this.textParent.addChild(this.topText[i]);
      this.textParent.alpha = 1;
    }
    this.textParent.mask = this.lowerpartMask;
    this.createTween();

    this.emptyText = new PIXI.Text("...", this.textStyle);

    this.emptyText.x = this.topText[this.topText.length - 1].x - 20;
    this.parentContainer.addChild(this.emptyText);
    this.emptyText.alpha = 0;
    this.setDisplayNumbers(true);

    this.createUnavailableText();
    this.setAvailable(false);
  };

  private createUnavailableText = (): void => {
    const textStyleUnavailable = new PIXI.TextStyle({
      fontFamily: this.gameTextStyle.gameFont,
      fontSize: 35,
      fontWeight: "bold",
      fill: ["#ff0000"], // gradient
      stroke: "#000000",
      strokeThickness: 5,
    });

    this.unavailableText = new PIXI.Text(
      this.activeGameData.gameTextGeneral.Unavailable,
      textStyleUnavailable
    );
    this.unavailableText.x = -25;
    this.unavailableText.visible = false;
    this.parentContainer.addChild(this.unavailableText);
  };
  public setAvailable = (bool: boolean): void => {
    this.textParent.visible = bool;
    this.unavailableText.visible = !bool;
  };
  private createTween = (): void => {
    for (var i = 0; i < this.maxLength; i++) {
      this.topTween[i] = PIXI.tweenManager.createTween(this.topText[i]);
      this.topTween[i].from({ y: 0 }).to({ y: -45 });
      this.topTween[i].time = 500;
      this.topTween[i].easing = PIXI.tween.Easing.linear();

      this.topTween[i].on(
        "end",
        function(self: JackpotCounters) {
          self.resetPos();
        }.bind(this.topTween[i], this)
      );
      // this.topTween[i].start();//
      // this.topTween[i].loop=true;//
    }

    this.setInitialValue(this.currentValue);
  };

  public getTargetedValue = (): number => {
    return this.targetValue;
  };
  public setInitialValue(
    next: number //InitializeValue
  ) {
    // next=parseInt(next)
    if (next === undefined) {
      next = 0;
    }
    let nextValueString = next.toString();

    for (var i = 0; i < this.maxLength; i++) {
      if (i <= nextValueString.length - 1) {
        this.topText[this.maxLength - i - 1].text =
          nextValueString[nextValueString.length - i - 1];

        this.topText[this.maxLength - i - 1].alpha = 1;
      } else {
        this.topText[this.maxLength - i - 1].text = "0";
        this.topText[this.maxLength - i - 1].alpha = 0;
        //Fix the value if te display value get lower than 1
        if (next < 100) {
          this.topText[this.maxLength - 3].alpha = 1;
        }
        if (next < 10) {
          this.topText[this.maxLength - 2].alpha = 1;
        }
        if (next < 1) {
          this.topText[this.maxLength - 1].alpha = 1;
        }
      }

      this.setNext();
      this.topText[i].y = 0;
    }
    this.currentValue = next;
    this.nextValue = next + 1;
  }

  private setNext = (): void => {
    for (var i = 0; i < this.maxLength; i++) {
      if (parseInt(this.topText[this.maxLength - i - 1].text) != 9) {
        // this.botText[this.maxLength -i-1].text=nextString[this.maxLength-i-1];// parseInt(this.topText[this.maxLength-i-1].text)+1;
        // console.log(this.nextValue," ", this.step,this.nextValue[this.maxLength-i-1])
        this.botText[this.maxLength - i - 1].text = (
          parseInt(this.topText[this.maxLength - i - 1].text) + 1
        ).toString();
      } else {
        this.botText[this.maxLength - i - 1].text = "0";
      }
    }
  };

  private resetPos = (): void => {
    for (var i = 0; i < this.maxLength; i++) {
      this.topTween[i].stop();
      this.topTween[i].reset();
      this.topText[i].y = 0;
    }
    if (this.reset) {
      this.reset = false; //
      this.setInitialValue(this.nextValue);
      this.newCycle();
    }

    // else {
    //     for (var i = 0; i < this.maxLength; i++) {
    //         this.topTween[i].stop();
    //         this.topTween[i].reset();
    //         this.topText[i].y = 0;
    //     }
    // }
  };

  private newCycle = (): void => {
    // console.log("here",this.currentValue,this.targetValue)

    if (this.currentValue < this.targetValue) {
      this.matchDisplaytoValue();
    }
  };

  private matchDisplaytoValue = (): void => {
    this.reset = true;
    this.animationSwitch();
    let current = this.currentValue.toString();
    this.nextValue = this.currentValue + this.step;

    // for (var i = ((this.nextValue).toString()).length-1;i>=0; i--) {
    for (var i = 0; i < this.nextValue.toString().length; i++) {
      let textA: number = parseInt(current[i]);
      let textB: number = parseInt(this.nextValue.toString()[i]);

      if (textA != textB) {
        this.topTween[
          this.maxLength - this.nextValue.toString().length + i
        ].reset();
        this.topTween[
          this.maxLength - this.nextValue.toString().length + i
        ].start();
      }
    }
  };

  private animationSwitch = (): void => {
    //change speed dynamically depending on value
    this.deltaValue = this.targetValue - this.currentValue;
    this.setSpeed();
    if (this.speed < 45) {
      // console.log("fastSpeed")
      // console.log(parseInt(this.deltaValue/10))
      this.step = Math.round(this.deltaValue * 0.1); //--
      // this.skipAnimation = true;
    } else {
      // console.log("Speed")
      this.step = 1;
      // this.skipAnimation = false;
      // console.log("play",this.step)
    }
  };

  //play animation when speed at some speed only
  public setAnimationTargetValue = (targetStopValue: number): void => {
    this.startTime = Date.now();
    this.step = 1; //reset default
    this.targetValue = targetStopValue;

    if (this.targetValue > this.currentValue) {
      this.matchDisplaytoValue();
    } else if (this.targetValue < this.currentValue) {
      this.setInitialValue(this.targetValue); //reset
    }
  };

  public setInitalValue = (targetStopValue: number): void => {
    this.startTime = Date.now();
    this.step = 1; //reset default
    this.targetValue = targetStopValue;
    this.matchDisplaytoValue();
  };

  private setSpeed = (): void => {
    let deltaTime = Date.now();
    let delta = deltaTime - this.startTime;
    //  delta=0;
    // console.log("time:",delta ,"  speed: " ,this.speed)
    if (this.deltaValue > 0) {
      this.speed = (this.animationTimeToTarget - delta / 2) / this.deltaValue;
      for (var i = 0; i < this.maxLength; i++) {
        this.topTween[i].time = this.speed;
      }

      // this.setStep();
    }
  };

  public setPosition = (posX: number, posY: number): void => {
    this.parentContainer.x = posX;
    this.parentContainer.y = posY;
    // parent.addChild(this.parentContainer);
  };
  public setChildOf = (parent: PIXI.Container): void => {
    parent.addChild(this.parentContainer);
  };

  public setDisplayNumbers = (bool: boolean): void => {
    if (bool) {
      this.emptyText.alpha = 0;
      this.textParent.alpha = 1;
    } else {
      this.emptyText.alpha = 1;
      this.textParent.alpha = 0;
    }
  };

  public getTextWidth = (): number => {
    return this.textParent.width;
  };
}
